<template lang="pug">
.ber-area-rating
  .label {{ label }}
  .ber-rating-info
    .ber-rating-label BER
    .ber-rating-value(
      v-if="displayRating.value !== 0"
      :class="[displayRating.code.toLowerCase()]"
      :style="{ backgroundColor: ratingColor || '#FFFFFF', color: pickTextOn(ratingColor) }"
    ) {{ displayRating.code }}
    .ber-rating-not-aplicable(v-else) N/A
</template>

<script lang="ts">
import { PropType, computed, defineComponent } from "vue";
import type { Rating } from "@/types";
import {
  getSimplifiedIrlBerRatingColor,
  pickTextOn,
  simplifyIrlBerRating,
} from "@/helpers";

export default defineComponent({
  props: {
    label: {
      type: String,
    },
    rating: {
      type: Object as PropType<Rating>,
      required: true,
    },
  },
  setup(props) {
    const displayRating = computed(() => simplifyIrlBerRating(props.rating));
    const ratingColor = computed(() =>
      getSimplifiedIrlBerRatingColor(displayRating.value.code)
    );

    return { displayRating, ratingColor, pickTextOn };
  },
});
</script>

<style scoped lang="scss">
.ber-area-rating {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .label {
    font-size: 0.9rem;
    color: $primary-color;
    font-weight: 700;
    padding: 0.25rem 0;
    border-bottom: 1px solid $border-color;
    text-transform: uppercase;
    padding-bottom: 0.5rem;
  }

  .ber-rating-info {
    display: flex;
    width: 100%;

    & > div {
      flex: 1;
      text-align: center;
      padding: 0.5rem;
      font-weight: 700;
    }

    .ber-rating-label {
      background: #363636;
      color: white;
      position: relative;
      $tringle-size: 0.5rem;

      &:after {
        content: "";
        position: absolute;
        right: -$tringle-size;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 0;
        height: 0;
        border-top: $tringle-size solid transparent;
        border-bottom: $tringle-size solid transparent;
        border-left: $tringle-size solid rgb(46, 46, 46);
      }
    }

    .ber-rating-not-aplicable {
      background-color: #ababab;
      color: white;
    }
  }
}
</style>
